import './styles/section.our-quality.scss';
import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
const tabHeaders = document.querySelectorAll('.oq__tab-title');
const tabs = document.querySelectorAll('.oq__tab');
let tabActive = 0;
const prev = document.querySelectorAll('.oq__prev');
const next = document.querySelectorAll('.oq__next');
const switchTab = (tabName) => {
    tabHeaders.forEach((elem, index) => {
        if (elem.dataset.tab === tabName) {
            elem.classList.add('tab-active');
            tabActive = index;
        }
        else {
            elem.classList.remove('tab-active');
        }
    });
    tabs.forEach((elem) => {
        if (elem.dataset.tab === tabName) {
            elem.classList.add('tab-active');
        }
        else {
            elem.classList.remove('tab-active');
        }
    });
};
tabHeaders.forEach((elem) => {
    elem.addEventListener('click', () => {
        if (elem.classList.contains('tab-active'))
            return;
        switchTab(elem.dataset.tab ?? '');
    });
});
prev.forEach((elem) => {
    elem.addEventListener('click', () => {
        const length = tabHeaders.length;
        const tabName = tabHeaders[tabActive === 0 ? length - 1 : tabActive - 1].dataset.tab;
        switchTab(tabName ?? '');
    });
});
next.forEach((elem) => {
    elem.addEventListener('click', () => {
        const length = tabHeaders.length;
        const tabName = tabHeaders[tabActive === length - 1 ? 0 : tabActive + 1].dataset.tab;
        switchTab(tabName ?? '');
    });
});
const getTabName = (layout) => {
    return layout.includes('Framed Print')
        ? 'framed-print'
        : layout.includes('Framed Canvas') ? 'framed-canvas' : 'canvas';
};
document.addEventListener('DOMContentLoaded', () => {
    if (isNotNullOrUndef(window.productPage?.getData)) {
        const layout = window.productPage.getData().layout;
        isNotNullOrUndef(layout) && switchTab(getTabName(layout));
        window.productPage.watcher.layout((layout) => {
            switchTab(getTabName(layout));
        });
    }
    else {
        document.querySelectorAll('.Layout-labels').forEach((elem) => {
            elem.addEventListener('click', () => {
                const layout = elem.getAttribute('avalue');
                switchTab(getTabName(layout ?? ''));
            });
        });
    }
});
const video = document.querySelector('.oq__section video');
if (isNotNullOrUndef(video)) {
    const sendVideoEvent = () => {
        window.removeEventListener('unload', sendVideoEvent);
    };
    video.addEventListener('play', () => {
        window.addEventListener('unload', sendVideoEvent);
    });
    video.addEventListener('pause', sendVideoEvent);
}
